module.exports = require("i18next-fs-backend");